import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-indsms-vertical-component',
  templateUrl: './indsms-vertical-component.component.html',
  styleUrls: ['./indsms-vertical-component.component.css']
})
export class IndsmsVerticalComponentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
